var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{staticClass:"approval-top-line",attrs:{"cols":"12"}},[_c('b-btn',{attrs:{"disabled":!_vm.selected.length,"title":_vm.title,"variant":"success"},on:{"click":_vm.billInvoices}},[_vm._v("\n      "+_vm._s(_vm.$t('buttons.common.bill_and_post'))+"\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d38c380","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/invoices-approval/ApprovalTopLine.vue
// module id = null
// module chunks = 